import { PipeTransform, Pipe } from "@angular/core";

@Pipe({
    name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {
    transform(value: string): any {
        if (value != null && value != 'NaN' && value != '') {
            var val = parseFloat(value.toString().replace(/,/g, ''))
            let retNumber = Number(val);
            return isNaN(retNumber) ? 0 : retNumber;
        }
    }
}